import React from 'react';
import ImplBlock1Hero from '../implementacion/ImplBlock1Hero';
import ImplBlock1_5Institutional from '../implementacion/ImplBlock1_5Institutional';
import ImplBlock2Inputs from '../implementacion/ImplBlock2Inputs';
import ImplBlock3Responsibilities from '../implementacion/ImplBlock3Responsibilities';
import ImplBlock4Phases from '../implementacion/ImplBlock4Phases';
import ImplBlock5Ecosystem from '../implementacion/ImplBlock5Ecosystem';
import ImplBlock6Roles from '../implementacion/ImplBlock6Roles';
import ImplBlock7Metrics from '../implementacion/ImplBlock7Metrics';

export default function ImplementationPage() {
  return (
    <>
      <ImplBlock1Hero />
      <ImplBlock1_5Institutional />
      <ImplBlock2Inputs />
      <ImplBlock3Responsibilities />
      <ImplBlock4Phases />
      <ImplBlock5Ecosystem />
      <ImplBlock6Roles />
      <ImplBlock7Metrics />
    </>
  );
}
